export const FETCH_ANSWERS = "[Answers] Fetch Data";
export const SET_DATA = "[Answers] Set Data";
